<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="接口名称">
                  <el-input style="width: 177px" v-model="queryForm.apiName"></el-input>
              </el-form-item>
              <el-form-item label="接口账号">
                  <el-input style="width: 177px" v-model="queryForm.apiUser"></el-input>
              </el-form-item>
              <el-form-item label="是否默认">
<!--                  <el-input  v-model="queryForm.defaultType"></el-input>-->
                  <el-select clearable style="width: 177px" v-model="queryForm.defaultType" placeholder="请选择" size="small">
                      <el-option label="使用默认接口" :value="0"></el-option>
                      <el-option label="使用非默认接口" :value="1"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="调用方法">
                  <el-input style="width: 177px" v-model="queryForm.apiMethod"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getApiSmsApiList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addApiSmsApi"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editApiSmsApi(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteApiSmsApi(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshApiSmsApiList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="apiSmsApiList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="apiName"
        label="接口名称"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="apiUrl"
        label="接口网址"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="apiUser"
        label="接口账号"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="apiPwd"
        label="接口密码"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="defaultType"
        label="是否默认"
        width="180"
      >
          <template slot-scope="scope">
            {{scope.row.defaultType==0?'使用默认接口':'使用非默认接口'}}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="apiMethod"
        label="调用方法"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="smsCode"
        label="内容编码"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkApiSmsApi(scop.row.apiId)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editApiSmsApi(scop.row.apiId)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteApiSmsApi(scop.row.apiId)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="apiSmsApiStates[apiSmsApiState]"
      :visible.sync="showDialog"
      width="60%"
      :append-to-body="true"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="apiSmsApi"
          ref="apiSmsApiForm"
          :rules="rules"
          label-width="80px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="接口名称"
            prop="apiName"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="apiSmsApi.apiName"
              :disabled="apiSmsApiState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="接口网址"
            prop="apiUrl"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="apiSmsApi.apiUrl"
              :disabled="apiSmsApiState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="接口账号"
            prop="apiUser"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="apiSmsApi.apiUser"
              :disabled="apiSmsApiState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="接口密码"
            prop="apiPwd"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="apiSmsApi.apiPwd"
              :disabled="apiSmsApiState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="是否默认"
            prop="defaultType"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="apiSmsApi.defaultType"-->
<!--              :disabled="apiSmsApiState == 'check'"-->
<!--            ></el-input>-->
              <el-select clearable style="width: 177px" :disabled="apiSmsApiState == 'check'" v-model="apiSmsApi.defaultType" placeholder="请选择" size="small">
                  <el-option label="使用默认接口" :value="0"></el-option>
                  <el-option label="使用非默认接口" :value="1"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="调用方法"
            prop="apiMethod"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="apiSmsApi.apiMethod"
              :disabled="apiSmsApiState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="内容编码"
            prop="smsCode"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="apiSmsApi.smsCode"
              :disabled="apiSmsApiState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="apiSmsApiState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetApiSmsApiList();
                    this.getApiSmsApiList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetApiSmsApiList();
                    this.getApiSmsApiList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     apiName: '', //接口名称
                     apiUrl: '', //接口网址
                     apiUser: '', //接口账号
                     apiPwd: '', //接口密码
                     defaultType: '', //0:使用默认接口 1：使用非默认接口
                     apiMethod: '', //调用的方法
                     smsCode: '', //内容编码
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                apiSmsApiState: 'add',
                apiSmsApiStates: {
                    add: '新建接口管理',
                    check: '查看接口管理',
                    edit: '修改接口管理'
                },

                multipleSelection: [],
                apiSmsApiList: [],
                apiSmsApi: {
                    apiName: '', //接口名称
                    apiUrl: '', //接口网址
                    apiUser: '', //接口账号
                    apiPwd: '', //接口密码
                    defaultType: '', //0:使用默认接口 1：使用非默认接口
                    apiMethod: '', //调用的方法
                    smsCode: '', //内容编码
                },
                btnLoading: false,

                rules: {
                    apiName: [{ required: true, message: '接口名称不能为空', trigger: 'blur' }],
                    apiUrl: [{ required: true, message: '接口网址不能为空', trigger: 'blur' }],
                    apiUser: [{ required: true, message: '接口账号不能为空', trigger: 'blur' }],
                    apiPwd: [{ required: true, message: '接口密码不能为空', trigger: 'blur' }],
                    defaultType: [{ required: true, message: '是否默认不能为空', trigger: 'blur' }],
                    apiMethod: [{ required: true, message: '调用方法不能为空', trigger: 'blur' }],
                    smsCode: [{ required: true, message: '内容编码不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            // this.getApiSmsApiList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            init(){
                this.getApiSmsApiList();
            },
            resetApiSmsApiList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.apiSmsApiList = [];
            },
            resetDialog() {
                this.apiSmsApiState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      apiName: '', //接口名称
                      apiUrl: '', //接口网址
                      apiUser: '', //接口账号
                      apiPwd: '', //接口密码
                      defaultType: '', //0:使用默认接口 1：使用非默认接口
                      apiMethod: '', //调用的方法
                      smsCode: '', //内容编码
                };
                this.getApiSmsApiList();
            },
            closeDialog() {
                this.showDialog = false
                this.apiSmsApi = {
                      apiName: '', //接口名称
                      apiUrl: '', //接口网址
                      apiUser: '', //接口账号
                      apiPwd: '', //接口密码
                      defaultType: '', //0:使用默认接口 1：使用非默认接口
                      apiMethod: '', //调用的方法
                      smsCode: '', //内容编码
                };
            },
            submitForm() {
                if (this.apiSmsApiState == 'add') {
                    this.$refs.apiSmsApiForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/api/smsapi/add`,{ ...this.apiSmsApi }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetApiSmsApiList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.apiSmsApiState == 'edit') {
                    this.$refs.apiSmsApiForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/api/smsapi/edit`,{ ...this.apiSmsApi }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetApiSmsApiList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addApiSmsApi() {
                this.showDialog = true;
                this.apiSmsApiState = 'add';
            },
            checkApiSmsApi(apiSmsApiId) {
                console.log(apiSmsApiId);
                this.currentApiSmsApiId = apiSmsApiId;

                this.getApiSmsApiById();
                this.showDialog = true;
                this.apiSmsApiState = 'check';
            },
            editApiSmsApi(apiSmsApiId) {
                console.log('apiSmsApi', apiSmsApiId);
                if (apiSmsApiId) {
                    this.currentApiSmsApiId = apiSmsApiId;
                    this.getApiSmsApiById();
                } else {
                    this.apiSmsApi = { ...this.apiSmsApi, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.apiSmsApiState = 'edit';
            },
            deleteApiSmsApi(apiSmsApiId) {
                let ids = '';
                if (apiSmsApiId) {
                    ids = apiSmsApiId;
                } else {
                    ids = this.multipleSelection.map((apiSmsApi) => apiSmsApi.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/api/smsapi/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetApiSmsApiList();
                                this.getApiSmsApiList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshApiSmsApiList() {
                this.resetApiSmsApiList();
                this.getApiSmsApiList();
            },
            getApiSmsApiList(query = {}) {
                this.loading = true;
                get(`/api/smsapi/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.apiSmsApiList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getApiSmsApiById() {
                get(`/api/smsapi/get`,{ id: this.currentApiSmsApiId }).then((res) =>{
                    if(res.success){
                      this.apiSmsApi = { ...this.apiSmsApi, ...res.apiSmsApi };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportApiSmsApiList() {
                //this.btnLoading = true;
                exprotExcel(`/api/smsapi/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/api/smsapi/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/api/smsapi/importData`,formData);
              this.refreshApiSmsApiList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getApiSmsApiList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getApiSmsApiList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>